import { render, staticRenderFns } from "./customerservice.vue?vue&type=template&id=789e05fa&scoped=true"
import script from "./customerservice.vue?vue&type=script&lang=js"
export * from "./customerservice.vue?vue&type=script&lang=js"
import style0 from "./customerservice.vue?vue&type=style&index=0&id=789e05fa&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../../../../../../../opt/build-cache/yunying/node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "789e05fa",
  null
  
)

export default component.exports